import {DateTime, Interval} from "luxon";
import {Entity} from "./entity";

export class TimeFrame extends Entity<TimeFrame> {

    private _end: DateTime;

    private _start: DateTime;

    public get days(): number {
        return this.interval.count(`days`);
    }

    public get end(): DateTime {
        return this._end;
    }

    public set end(value: DateTime) {
        this._end = value;
    }

    public get interval(): Interval {
        return Interval.fromDateTimes(this._start, this._end);
    }

    public get start(): DateTime {
        return this._start;
    }

    public set start(value: DateTime) {
        this._start = value;
    }

    constructor(start: DateTime, end: DateTime) {
        super();
        this._start = start;
        this._end = end;
    }

    public async clone(): Promise<TimeFrame> {
        return Promise.resolve(new TimeFrame(this.start, this.end));
    }

    public toString(): string {
        return this.interval.toLocaleString();
    }

    public isInRange(dateTime: DateTime): boolean {
        return this.interval.contains(dateTime);
    }
}